(function () {
  if (customElements.get('bf-countdown')) return;

  class BFCountdown extends HTMLElement {
    connectedCallback() {
      this._labels = (this.dataset.labels || 'd,h,m,s').split(',');
      this._loopDaily = this.dataset.loopDaily === 'true';
      this._end = this._parseDate(this.dataset.end);
      this._target = this._resolveTarget();

      if (!this._target) {
        this.hidden = true;
        return;
      }

      this._render();
      this._tick();
      this._intervalId = setInterval(() => this._tick(), 1000);

      this._onVisibility = () => {
        if (document.hidden) {
          clearInterval(this._intervalId);
        } else {
          this._tick();
          this._intervalId = setInterval(() => this._tick(), 1000);
        }
      };
      document.addEventListener('visibilitychange', this._onVisibility);
    }

    disconnectedCallback() {
      clearInterval(this._intervalId);
      document.removeEventListener('visibilitychange', this._onVisibility);
    }

    _parseDate(value) {
      if (!value) return null;
      // Unix epoch (seconds) — timezone-exact, preferred format
      if (/^\d+$/.test(value)) {
        const date = new Date(parseInt(value, 10) * 1000);
        return isNaN(date.getTime()) ? null : date;
      }
      const date = new Date(value.includes('T') ? value : value.replace(' ', 'T'));
      return isNaN(date.getTime()) ? null : date;
    }

    _resolveTarget() {
      const now = new Date();
      if (this._end && this._end.getTime() > now.getTime()) return this._end;
      if (this._loopDaily) return this._nextMidnight();
      return null;
    }

    _nextMidnight() {
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      return midnight;
    }

    _render() {
      this._units = [];
      const fragment = document.createDocumentFragment();

      ['days', 'hrs', 'mins', 'secs'].forEach((name, index) => {
        if (index > 0) {
          const separator = document.createElement('span');
          separator.className = 'bf-countdown__separator';
          separator.textContent = ':';
          separator.dataset.for = name;
          fragment.appendChild(separator);
        }

        const unit = document.createElement('span');
        unit.className = 'bf-countdown__unit bf-countdown__unit--' + name;
        fragment.appendChild(unit);
        this._units.push(unit);
      });

      this.replaceChildren(fragment);
    }

    _tick() {
      const now = new Date();
      let diff = this._target.getTime() - now.getTime();

      if (diff <= 0) {
        this._target = this._resolveTarget();
        if (!this._target) {
          this.hidden = true;
          clearInterval(this._intervalId);
          return;
        }
        diff = this._target.getTime() - now.getTime();
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      const values = [days, hours, minutes, seconds];
      values.forEach((value, index) => {
        this._units[index].textContent = String(value).padStart(2, '0') + this._labels[index];
      });

      const hideDays = days === 0;
      this._units[0].hidden = hideDays;
      const daysSeparator = this.querySelector('[data-for="hrs"]');
      if (daysSeparator) daysSeparator.hidden = hideDays;
    }
  }

  customElements.define('bf-countdown', BFCountdown);
})();
